module.exports = __webpack_public_path__ + "img/TVOCmg.bb896d60.png";